"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

function triggerTracking(dataLayerObject) {
  var dataLayer = window.dataLayer || [];
  Array.isArray(dataLayerObject) ? dataLayer.push.apply(dataLayer, (0, _toConsumableArray2.default)(dataLayerObject)) : dataLayer.push(dataLayerObject);
}

var _default = triggerTracking;
exports.default = _default;
//# sourceMappingURL=index.js.map